import React from 'react';
import Webcam from 'react-webcam';

const CameraModal = ({ show, onClose, cameraResOptions, cameraResolution, setCameraResolution, webcamRef, handleCapture }) => {
  if (!show) return null;
  return (
    <div className="modal d-block" tabIndex="-1" style={{ background: 'rgba(0,0,0,0.5)' }}>
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Take a Photo</h5>
            <button type="button" className="btn-close" onClick={onClose}></button>
          </div>
          <div className="modal-body text-center">
            <div className="mb-2">
              <label htmlFor="cameraResSelect" className="form-label">Camera Quality:</label>
              <select
                id="cameraResSelect"
                className="form-select"
                value={cameraResOptions.findIndex(opt => opt.value.width === cameraResolution.width && opt.value.height === cameraResolution.height)}
                onChange={e => setCameraResolution(cameraResOptions[Number(e.target.value)].value)}
                style={{ maxWidth: 220, margin: '0 auto' }}
              >
                {cameraResOptions.map((opt, idx) => (
                  <option key={idx} value={idx}>{opt.label}</option>
                ))}
              </select>
            </div>
            <Webcam
              audio={false}
              ref={webcamRef}
              screenshotFormat="image/png"
              videoConstraints={{ facingMode: 'environment', ...cameraResolution }}
              style={{ width: '100%', borderRadius: 12 }}
            />
            <button className="btn btn-success mt-3" onClick={handleCapture}>Capture & Analyze</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CameraModal;
